/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "./axios";

export function delMeet(data: { id: number | string; userId: string }) {
  return axios.delete("/reserve/delReserve", { data });
}


// 设置公告已读
// export function setNoticeRead(data: {
//   id: number;
// }) {
//   return axios.post("/notice/setNoticeRead", data);
// }

// 登录
export function loginAPI (data: any) {
  return axios.post("/web/user", data);
}

// 登出
export function logoutAPI() {
  return axios.put("/web/user");
}

// 用户信息
export function getUserInfoAPI() {
  return axios.get("/web/user");
}

// 用户验证码
export function getPhoneCode(data: any) {
  return axios.get("/web/user/code?phone="+data.phone, data);
}

// 获取消息列表
export function getUserMessageInfo() {
  return axios.get("/front/student/message");
}

// 已读未读
export function frontUserMessage(id: any) {
  return axios.put("/front/student/message/"+ id);
}
export function frontUserMessageBatch(data: any) {
  return axios.put("/front/student/message/batch", data);
}
// 获取用户协议隐私
export function getLegalPdf(data: any) {
  return axios.get("/front/resource/legalPdf?type=" + data.type, data);
}
// 考试年龄列表
export function getExamRescource() {
  return axios.get("/front/resource/exam");
}
export function getreSourcePoint(params: Record<string, any> = {}) {
  const clean: Record<string, any> = {}
  Object.keys(params).forEach(k => {
    const v = params[k]
    if (v !== null && v !== undefined && v !== '') clean[k] = v
  })
  return axios.get('/resource/point', { params: clean })
}
export function getPositionRescource(data: any) {
  if (!data.channelCode) delete data.channelCode;
  return axios.post("/resource/position", data);
}
export function updateOrderPosition(id: any, data: any) {
  return axios.put("/front/order/"+ id, data);
}
export function verifyChannel(data: any) {
  return axios.post("/front/order/resolveChannelCode", data);
}
export function getPayNumberRescource(data: any) {
  return axios.post("/front/order/getPrice", data);
}
export function getOrderRescource() {
  return axios.get("/front/order/all");
}
export function getOrderDetailRescource(id: any) {
  return axios.get('/front/order/' + id);
}
export function deleteOrder(id: any) {
  return axios.delete('/front/order/' + id);
}
export function cancelOrder(id: any) {
  return axios.put('/front/order/cancel/' + id);
}
export function isReselectPosition(id: any) {
  return axios.get('/front/order/beforeUpdate/' + id);
}
export function isBackOrderDetail(id: any) {
  return axios.get('/front/order/beforeRefund/' + id);
}
export function backOrder(data: any) {
  return axios.put('/front/order/refund/', data);
}
// 新建支付订单
export function getPayRescorce(data: any) {
  return axios.post("/front/order", data);
}
// 未支付订单获取支付参数
export function getOrderPayRescorce(data: any) {
  return axios.get(`/front/order/pay/${data.id}/${data.language}?isWeb=${data.isWeb}`);
}
export function queryOrderPayDetail(data: any) {
  return data.orderId ? axios.get(`/pay/queryOrder?reqsn=` + data.reqsn + '&orderId=' +  data.orderId) : axios.get(`/pay/queryOrder?reqsn=` + data.reqsn)
}
// 获取常见问题
export function getPdfRescource(data: any) {
  return axios.get('/front/resource/pdf?type='+ data.type, {});
}
//  图形验证图片
export function queryCaptcha(data: any) {
  return axios.get('/captcha', {});
}
// 图形验证
export function getCaptchaVerify(data: any) {
  return axios.post("/captcha/verify", data);
}
//
export function setApplyInvoice(data: any) {
  return axios.post("/invoice/apply", data);
}
export function getApplyInvoiceStatus(orderId: any) {
  return axios.get('/invoice/status?orderId='+ orderId, {});
}
//
export function getButtonStatus(orderId: any) {
  return axios.get('/front/order/buttonStatus/'+ orderId);
}
export function getTransferOrderId(data: any) {
  return axios.post('/front/order/transfer/'+ data.orderId, data);
}

export function getReconsiderationAll() {
  return axios.get('/front/reconsideration/all');
}

// 复议模块列表
export function getReconsiderationModules() {
  return axios.get('/front/reconsideration/modules');
}

// 可关联订单
export function getReconsiderationOrders(data: any) {
  return axios.get('/front/reconsideration/orders', { params: data });
}

// 获取支付参数
export function getOrderPayReconsideration(data: { id: any; language: any , examId: string, type: string, isWeb: boolean }) {
  return axios.get(`/front/reconsideration/pay/${data.id}/${data.language}`, { params: {examId: data.examId, type: data.type, isWeb: data.isWeb} });
}

// 申诉/复议详情
export function getOrderPayReconsiderationDetail(id: any, examId: string, type: string) {
  return axios.get(`/front/reconsideration/${id}`, { params: {examId: examId, type: type} });
}

// 申请复议
export function getReconsiderationOrderId(data: any) {
  return axios.post('/front/reconsideration', data);
}

// 申请申诉
export function getReconsiderationAppealOrderId(data: any) {
  return axios.post('/front/reconsideration/appeal', data);
}

// 获取申请复议发票申请状态
export function getReconsiderationtatus(reconsiderationId: any) {
  return axios.get('/invoice/status?reconsiderationId='+ reconsiderationId, {});
}
// 申请复议发票申请
export function setReconsiderationApplyInvoice(data: any) {
  return axios.post("/invoice/apply", data);
}
//查询支付状态
export function queryReconsiderationOrderPayDetail(data: any) {
  return axios.get(`/front/reconsideration/payStatus/${data.orderId}/?reqsn=` + data.reqsn)
}